var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: [
        "box-item add-dc-to-classroom-box",
        { opened: _vm.showClassrooms }
      ]
    },
    [
      _c("transition", { attrs: { name: "fade" } }, [
        !_vm.showClassrooms
          ? _c("div", { key: "1" }, [
              _c("button", {
                staticClass: "btn btn-add-to-classroom",
                domProps: { textContent: _vm._s(_vm.displayLabel) },
                on: {
                  click: function($event) {
                    _vm.showClassrooms = true
                  }
                }
              })
            ])
          : _c("div", { key: "2" }, [
              _c(
                "button",
                {
                  staticClass: "close",
                  on: {
                    click: function($event) {
                      _vm.showClassrooms = false
                    }
                  }
                },
                [_vm._v("Close")]
              ),
              _vm._v(" "),
              _c("header", [_c("h3", [_vm._v(_vm._s(_vm.displayLabel))])]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "form-content" },
                [
                  _vm._l(_vm.classrooms, function(classroom) {
                    return _c(
                      "fieldset",
                      { key: classroom.id, staticClass: "b-vspace-s" },
                      [
                        _c("label", { staticClass: "checkbox" }, [
                          _c("span", {
                            staticClass: "icon css-sprite-dailyproblems"
                          }),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.classroomIds,
                                expression: "classroomIds"
                              }
                            ],
                            attrs: { type: "checkbox", name: "tracks" },
                            domProps: {
                              value: classroom.id,
                              checked: Array.isArray(_vm.classroomIds)
                                ? _vm._i(_vm.classroomIds, classroom.id) > -1
                                : _vm.classroomIds
                            },
                            on: {
                              change: function($event) {
                                var $$a = _vm.classroomIds,
                                  $$el = $event.target,
                                  $$c = $$el.checked ? true : false
                                if (Array.isArray($$a)) {
                                  var $$v = classroom.id,
                                    $$i = _vm._i($$a, $$v)
                                  if ($$el.checked) {
                                    $$i < 0 &&
                                      (_vm.classroomIds = $$a.concat([$$v]))
                                  } else {
                                    $$i > -1 &&
                                      (_vm.classroomIds = $$a
                                        .slice(0, $$i)
                                        .concat($$a.slice($$i + 1)))
                                  }
                                } else {
                                  _vm.classroomIds = $$c
                                }
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c("span", { staticClass: "b-checkbox" }),
                          _vm._v(" "),
                          _c("span", { staticClass: "name" }, [
                            _vm._v(_vm._s(classroom.name))
                          ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "value" })
                        ])
                      ]
                    )
                  }),
                  _vm._v(" "),
                  _c(
                    "footer",
                    [
                      _c(
                        "Button",
                        {
                          staticClass: "btn btn-save btn-accent btn-outline",
                          attrs: { loading: _vm.saveInProgress },
                          on: { click: _vm.save }
                        },
                        [_vm._v("Save")]
                      ),
                      _vm._v(" "),
                      _c("transition", [
                        _vm.statusMessage.length
                          ? _c(
                              "span",
                              {
                                class: [
                                  "save-status",
                                  { "is-error": _vm.isUpdateError }
                                ]
                              },
                              [_vm._v(_vm._s(_vm.statusMessage))]
                            )
                          : _vm._e()
                      ])
                    ],
                    1
                  )
                ],
                2
              )
            ])
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }